import { render } from "./propertiesSeparator.vue?vue&type=template&id=b73eba6a"
import script from "./propertiesSeparator.vue?vue&type=script&lang=js"
export * from "./propertiesSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__